import UserResource from '@/api/resources/user'
import AlarmResource from '@/api/resources/alarm'
import { defineStore } from 'pinia'
import { IShift } from '@/interfaces/entities/shifts'
import { IUserLight } from '@/interfaces/entities/user'
import { IAlarmTypeConfig, ICompany } from '@/interfaces/entities/company'

export const useCompanyStore = defineStore({
  id: 'companies',
  persist: {
    paths: ['companies', 'currentCompany', 'shifts', 'alarmTypeConfigs', 'users'],
  },

  state: () => ({
    companies: [] as ICompany[],
    allCompanies: [] as ICompany[],
    currentCompany: {} as ICompany,
    shifts: [] as IShift[],
    alarmTypeConfigs: [] as IAlarmTypeConfig[],
    users: [] as IUserLight[],
  }),

  getters: {
    getCurrentCompany: (state) => state.currentCompany,
    getCompanies: (state) => state.companies,
    getAllCompanies: (state) => state.allCompanies,
    getCompanyUsers: (state) => state.users,
    getCurrentCompanyId: (state) => state.currentCompany?.id ?? '',
    hasMixingCyclesEnabled: (state) => state.currentCompany?.mixing_cycles_enabled ?? false,
    usesFreeMarket: (state) => {
      const flag = state.currentCompany?.uses_free_market
      return flag === 1
    },
    hasShifts: (state) => state.shifts.length > 0,
    getAlarmTypeConfigs: (state) =>
      Array.isArray(state.alarmTypeConfigs) ? state.alarmTypeConfigs : [],
  },

  actions: {
    async fetchCompanies() {
      const response = await UserResource.getCompanies()

      this.companies = response
      this.currentCompany = this.companies[0]
    },

    async fetchAllCompanies() {
      const response = await UserResource.getAllCompanies()

      this.allCompanies = response
    },

    async fetchCompanyUsers() {
      try {
        const response = await UserResource.getCompanyUsers()
        this.users = response.filter(user => user.name !== 'Worker BEM') || []
      } catch {
        // Erro ao buscar usuários da empresa
      }
    },

    async fetchCompanyUsersByCompanyId(companyId: number) {
      try {
        const response = await UserResource.getCompanyUsers(companyId)
        this.users = response.filter((user: IUserLight) => user.name !== 'Worker BEM') || []
      } catch {
        this.users = []
      }
    },

    async setCurrentCompany(companyId: number) {
      const company = this.companies.find((c) => c.id === companyId)
      if (company) {
        this.currentCompany = company
      }
    },

    async fetchCompanyAlarmTypes() {
      try {
        const raw = await AlarmResource.getAlarmTypeConfigsByCompany()
        this.alarmTypeConfigs = Array.isArray(raw) ? raw : (raw as { alarm_type_configs?: IAlarmTypeConfig[] })?.alarm_type_configs ?? []
      } catch {
        this.alarmTypeConfigs = []
      }
    },

    setCompanies(companies: ICompany[]) {
      this.companies = companies
    },

    async fetchCompanyShifts() {
      try {
        const raw = await UserResource.getCompanyShifts()
        this.shifts = Array.isArray(raw) ? raw : (raw as { shifts?: IShift[] })?.shifts ?? []
      } catch {
        this.shifts = []
      }
    },
  },
})
